module.exports = __webpack_public_path__ + "static/media/profile-picture-676w.1f6b1bcf.webp";